// extracted by mini-css-extract-plugin
module.exports = {"hidden":"bookmarkButton_hidden___yi_i","textEmphasis":"bookmarkButton_textEmphasis__VO8aJ","bookmarkBtn":"bookmarkButton_bookmarkBtn__SNK3G"};